import * as _ from 'lodash';

import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { NumberRange } from './numberRange';
import { customFnValidatorFn } from 'src/app/shared/validators/customFn.validator';
import { NumberRangeValidator } from 'src/app/shared/validators/number-range.validator';

@Component({
  selector: 'app-number-range-editor',
  templateUrl: './number-range-editor.component.html',
  styleUrls: ['./number-range-editor.component.scss'],
})
export class NumberRangeEditorComponent implements OnInit {
  private readonly minNumberName: string = 'minNumber';
  private readonly maxNumberName: string = 'maxNumber';
  @Input()
  uiTypeComplex: boolean = false;
  constructor() {}

  ngOnInit() {
    this.formGroup = new UntypedFormGroup({
      minNumber: new UntypedFormControl(null, [
        customFnValidatorFn(() => this.rangeError, 'minNumberError'),
        NumberRangeValidator(0, NaN, 'Min'),
      ]),
      maxNumber: new UntypedFormControl(null, [
        customFnValidatorFn(() => this.rangeError, 'maxNumberError'),
        NumberRangeValidator(0, NaN, 'Max'),
      ]),
    });
    this.formGroup.setValidators([customFnValidatorFn(() => this.rangeError, 'rangeError')]);
  }

  get minimum(): string {
    return this.uiTypeComplex ? `Minimum number of entries:` : `Minimum value:`;
  }
  get maximum(): string {
    return this.uiTypeComplex ? `Maximum number of entries:` : `Maximum value::`;
  }

  public formGroup: UntypedFormGroup;

  @Output()
  public rangeChanged: EventEmitter<NumberRange> = new EventEmitter<NumberRange>();

  @Input()
  public get minNumber(): number {
    if (!this.formGroup) return null;
    return this.minNumberControl().value;
  }
  public set minNumber(value: number) {
    this.minNumberControl().setValue(value);
  }

  @Input()
  public get maxNumber(): number {
    if (!this.formGroup) return null;
    return this.maxNumberControl().value;
  }
  public set maxNumber(value: number) {
    this.maxNumberControl().setValue(value);
  }

  private get hasRange(): boolean {
    return _.isNumber(this.minNumber) && _.isNumber(this.maxNumber);
  }

  public get rangeError(): boolean {
    let hasError = this.hasRange && this.minNumber >= this.maxNumber;
    return hasError;
  }

  public fireRangeChangedEvent() {
    this.minNumberControl().updateValueAndValidity();
    this.maxNumberControl().updateValueAndValidity();
    var $event = { min: this.minNumber, max: this.maxNumber };
    this.rangeChanged.emit($event);
  }

  public readonly minNumberControl = (): UntypedFormControl =>
    this.formGroup.get(this.minNumberName) as UntypedFormControl;
  public readonly maxNumberControl = (): UntypedFormControl =>
    this.formGroup.get(this.maxNumberName) as UntypedFormControl;
}
